import React from 'react';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { isAuthenticated } from '../utils/auth';

function Home() {
  const navigate = useNavigate();
  const authenticated = isAuthenticated();

  return (
    <div>
      {/* Hero Section */}
      <div className="bg-primary text-white py-5" style={{ minHeight: '400px' }}>
        <Container className="d-flex flex-column justify-content-center" style={{ minHeight: '300px' }}>
          <Row className="align-items-center">
            <Col lg={6}>
              <h1 className="display-4 fw-bold mb-4">Join the Conversation Revolution</h1>
              <p className="lead mb-4">
                AI is changing how we interact. We'll help you find your voice.
              </p>
              <p className="mb-4">
                Create, license, and monetize custom AI voice models. Browse our marketplace
                to find the perfect voice for your project.
              </p>
              <div className="d-flex gap-3">
                <Button
                  variant="light"
                  size="lg"
                  onClick={() => navigate('/marketplace')}
                >
                  Explore Marketplace
                </Button>
                {!authenticated && (
                  <Button
                    variant="outline-light"
                    size="lg"
                    onClick={() => navigate('/login')}
                  >
                    Sign In
                  </Button>
                )}
              </div>
            </Col>
            <Col lg={6} className="text-center mt-4 mt-lg-0">
              <img
                src={`${process.env.PUBLIC_URL}/ursulai-logo-1.png`}
                alt="UrsulaI Platform"
                style={{ maxWidth: '100%', maxHeight: '300px', filter: 'drop-shadow(0 0 20px rgba(163, 144, 210, 0.3))' }}
                onError={(e) => {
                  console.error('Hero logo failed to load');
                  e.target.style.display = 'none';
                }}
              />
            </Col>
          </Row>
        </Container>
      </div>

      {/* Features Section */}
      <Container className="py-5">
        <h2 className="text-center mb-5">Platform Features</h2>
        <Row>
          <Col md={4} className="mb-4">
            <Card className="h-100 text-center border-0 shadow-sm">
              <Card.Body className="p-4">
                <div className="mb-3" style={{ fontSize: '3rem' }}>🎙️</div>
                <h4>Create Voice Models</h4>
                <p className="text-muted">
                  Upload audio samples and create custom AI voice models with advanced
                  training capabilities.
                </p>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} className="mb-4">
            <Card className="h-100 text-center border-0 shadow-sm">
              <Card.Body className="p-4">
                <div className="mb-3" style={{ fontSize: '3rem' }}>🛒</div>
                <h4>Marketplace</h4>
                <p className="text-muted">
                  Browse thousands of voice models, filter by language, gender, style,
                  and find the perfect match.
                </p>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} className="mb-4">
            <Card className="h-100 text-center border-0 shadow-sm">
              <Card.Body className="p-4">
                <div className="mb-3" style={{ fontSize: '3rem' }}>💰</div>
                <h4>Monetize & License</h4>
                <p className="text-muted">
                  License your voice models with flexible pricing tiers and earn revenue
                  from your creations.
                </p>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row className="mt-5">
          <Col md={4} className="mb-4">
            <Card className="h-100 text-center border-0 shadow-sm">
              <Card.Body className="p-4">
                <div className="mb-3" style={{ fontSize: '3rem' }}>🔊</div>
                <h4>Speech Synthesis</h4>
                <p className="text-muted">
                  Convert text to natural-sounding speech using licensed voice models
                  with high-quality output.
                </p>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} className="mb-4">
            <Card className="h-100 text-center border-0 shadow-sm">
              <Card.Body className="p-4">
                <div className="mb-3" style={{ fontSize: '3rem' }}>🔒</div>
                <h4>Secure & Private</h4>
                <p className="text-muted">
                  Enterprise-grade security with encrypted storage, secure authentication,
                  and privacy controls.
                </p>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4} className="mb-4">
            <Card className="h-100 text-center border-0 shadow-sm">
              <Card.Body className="p-4">
                <div className="mb-3" style={{ fontSize: '3rem' }}>⭐</div>
                <h4>Community Reviews</h4>
                <p className="text-muted">
                  Read reviews, listen to samples, and make informed decisions with
                  community ratings.
                </p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* CTA Section */}
      <div className="bg-light py-5">
        <Container className="text-center">
          <h2 className="mb-4">Ready to Get Started?</h2>
          <p className="lead text-muted mb-4">
            Join our platform today and explore the future of voice AI.
          </p>
          <div className="d-flex gap-3 justify-content-center">
            <Button
              variant="primary"
              size="lg"
              onClick={() => navigate(authenticated ? '/dashboard' : '/login')}
            >
              {authenticated ? 'Go to Dashboard' : 'Sign In Now'}
            </Button>
            <Button
              variant="outline-primary"
              size="lg"
              onClick={() => navigate('/marketplace')}
            >
              Browse Voices
            </Button>
          </div>
        </Container>
      </div>
    </div>
  );
}

export default Home;
